module.exports = __webpack_public_path__ + "../static/img/gt.4f9f2a04.png";